/* eslint-env jquery */
const $ = jQuery.noConflict();

'use strict';
const StoreMap = {

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function() {
		if ($('.acf-map').length) {
			this.renderMap();
		}
	},

	renderMap: function() {

		function initMap($el) {
			// Find marker elements within map.
			const $markers = $el.find('.marker');
			const country = 'United States';
			// Create gerenic map.
			const mapArgs = {
				zoom: $el.data('zoom') || 16,
				// eslint-disable-next-line no-undef
				mapTypeId: google.maps.MapTypeId.ROADMAP,
				disableDefaultUI: true, //disables controls
			};

			// eslint-disable-next-line no-undef
			const map = new google.maps.Map($el[0], mapArgs);
			// eslint-disable-next-line no-undef
			const geocoder = new google.maps.Geocoder();

			geocoder.geocode({'address': country}, function(results, status) {
				// eslint-disable-next-line no-undef
				if (status === google.maps.GeocoderStatus.OK) {
					map.setCenter(results[0].geometry.location);
					map.setZoom(4);
				} else {
					alert('Could not find location: ' + location);
				}
			});


			// Add markers.
			map.markers = [];
			$markers.each(function(){
				initMarker($(this), map);
				addMarkerFromJson($(this), map);
			});

			// Center map based on markers.
			centerMap(map);

			// Return map instance.
			StoreMap.map = map;
			return map;
		}

		/**
		 * initMarker
		 *
		 * Creates a marker for the given jQuery element and map.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @return  object The marker instance.
		 * @param $marker
		 * @param map
		 */
		function initMarker($marker, map) {
			// Get position from marker.
			const lat = $marker.data('lat');
			const lng = $marker.data('lng');
			const latLng = {
				lat: parseFloat(lat),
				lng: parseFloat(lng),

			};
			// eslint-disable-next-line no-undef
			const marker = new google.maps.Marker({
				position: latLng,
				map: map,
			});

			// Append to reference for later use.
			map.markers.push(marker);

			// If marker contains HTML, add it to an infoWindow.
			if($marker.html()){
				// Create info window.
				// eslint-disable-next-line no-undef
				const infowindow = new google.maps.InfoWindow({
					content: $marker.html()
				});

				// Show info window when marker is clicked.
				// eslint-disable-next-line no-undef
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open(map, marker);
				});
			}
		}

		// eslint-disable-next-line no-unused-vars
		function addMarkerFromJson($marker, map) {

			// var
			// eslint-disable-next-line no-undef
			const latlng = new google.maps.LatLng($marker.lat, $marker.lng);

			// eslint-disable-next-line no-undef,camelcase
			const icon = $marker.icon ? mongotel_map.site_url + '/wp-content/themes/fws-mongotel/src/assets/images/shape2.png' : mongotel_map.site_url + '/wp-content/uploads/2021/07/reseller.png';

			// eslint-disable-next-line no-undef
			const marker = new google.maps.Marker({
				position: latlng,
				map: map,
				// eslint-disable-next-line no-undef,camelcase
				icon: icon
			});

			// add to array
			map.markers.push(marker);

			// if marker contains HTML, add it to an infoWindow
			if ($marker.html) {
				// create info window
				// eslint-disable-next-line no-undef
				const infowindow = new google.maps.InfoWindow({
					content: $marker.html
				});
				// show info window when marker is clicked
				// eslint-disable-next-line no-undef
				google.maps.event.addListener(marker, 'click', function() {
					infowindow.open(map, marker);
				});
			}

			if ($marker.str) {
				// create info window
				// eslint-disable-next-line no-undef
				const infoWindow = new google.maps.InfoWindow;
				infoWindow.setContent($marker.str);
				infoWindow.open(map, marker);
			}
		}

		/**
		 * centerMap
		 *
		 * Centers the map showing all markers in view.
		 *
		 * @date    22/10/19
		 * @since   5.8.6
		 *
		 * @return  void
		 * @param map
		 */
		function centerMap(map) {

			// Create map boundaries from all map markers.
			// eslint-disable-next-line no-undef
			const bounds = new google.maps.LatLngBounds();
			map.markers.forEach(function(marker){
				bounds.extend({
					lat: marker.position.lat(),
					lng: marker.position.lng()
				});
			});
			// Case: Single marker.
			// eslint-disable-next-line eqeqeq
			if(map.markers.length === 1){
				map.setCenter(bounds.getCenter());
				// Case: Multiple markers.
			} else{
				map.fitBounds(bounds);
			}
		}

		StoreMap.addMarkersFromResponse = function(value) {
			// eslint-disable-next-line no-unused-vars
			$.each(StoreMap.map.markers, function(i, marker) {
				StoreMap.map.markers[i].setMap(null);
			});

			// add markers
			$.each(value, function(key, value) {
				addMarkerFromJson(value, StoreMap.map);
			});
			centerMap(StoreMap.map);
		};

		// Render maps on page load.
		$(document).ready(function(){
			$('.acf-map').each(function(){
				// eslint-disable-next-line no-unused-vars
				const map = initMap($(this));
			});
		});

	}

};

export default StoreMap;
